import React from 'react';
import PropTypes from 'prop-types';

import './typeahead.scss';
import Itens from './itens';


const getItens = (itens, handleClick, handleMouseOver, handleMouseOut, isMouse) => (
    <div>
        {
            itens.map(item => <Itens
                key={item.key}
                item={item}
                onClick={handleClick}
                onMouseOver={handleMouseOver}
                onMouseOut={handleMouseOut}
                isMouseOver={isMouse} />)
        }
    </div>
);

const ItemList = (props) => {

    return (
        <div className="typeahead">
            <div className="list-itens">
                <div className={props.className}>
                    {getItens(props.itens, props.onClick, props.onMouseOver, props.onMouseOut, props.isMouse)}
                </div>
            </div>
        </div>
    )

}

ItemList.defaultProps = {
    itens: []
};

ItemList.propTypes = {
    itens: PropTypes.array
};

export default ItemList;

